var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u952E\\u751F\\u6210\\u79FB\\u52A8\\u7AEF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6211\\u7684",
    transform: "translate(-28.000000, -124.000000)",
    fill: "#2C2C2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u751F\\u6210\\u8BB0\\u5F55",
    transform: "translate(28.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4943654,2.1 L13.3626539,3.94390384 L10.4943654,5.78780769 L10.4943654,4.55853846 C6.87353366,4.55853846 3.93826923,7.49380289 3.93826923,11.1146346 C3.93826923,14.7354663 6.87353366,17.6707308 10.4943654,17.6707308 C14.1151971,17.6707308 17.0504615,14.7354663 17.0504615,11.1146346 C17.0504615,9.20519535 16.230078,7.43078364 14.828423,6.19531044 L14.7068598,6.09074572 L15.4972222,5.14922153 C17.2482202,6.61912021 18.2797308,8.78345997 18.2797308,11.1146346 C18.2797308,15.4143879 14.7940995,18.9 10.4943654,18.9 C6.19461211,18.9 2.709,15.4143687 2.709,11.1146346 C2.709,6.86113259 6.12006845,3.40431227 10.3559574,3.33047929 L10.4943654,3.32926923 L10.4943654,2.1 Z M10.9041154,7.01707692 L10.9041154,10.7048846 L13.3626539,10.7048846 L13.3626539,11.9341538 L9.67484616,11.9341538 L9.67484616,7.01707692 L10.9041154,7.01707692 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.b8051252084b77bf728f27e59bb10cc3.svg";
export { ForwardRef as ReactComponent };